import React from 'react';
import { CardBody, CardDivider } from 'is24-corecss';

type DataCardProps = {
  title: string;
  className?: string;
  button?: JSX.Element;
  children?: JSX.Element;
};

const DataCard: React.FC<DataCardProps> = ({ title, className, button, children }: DataCardProps) => {
  return (
    <CardBody className={'border margin-bottom-l ' + className} style={{ height: 'auto' }}>
      <div className="padding-l">
        <div className="grid grid-flex grid-justify-space-between">
          <p className="font-bold">{title}</p>
          {button}
        </div>
        <CardDivider />
        {children}
      </div>
    </CardBody>
  );
};

export default DataCard;
